<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>tag</md-icon>
                    </div>
                    <h4 class="title">Add Department</h4>
                </md-card-header>

                <form @submit.prevent="add">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.name" />
                                    <validation-error :errors="apiValidationErrors.name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Code
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.code" />
                                    <validation-error :errors="apiValidationErrors.code" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Short Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="department.short_name" />
                                    <validation-error :errors="apiValidationErrors.short_name" />
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Port
                            </label>
                            <div class="md-layout-item">
                                <md-field>
                                    <label>Select ...</label>
                                    <md-select v-model="department.port_id" name="port_id">
                                        <md-option
                                                v-for="port in available_ports"
                                                :key="'ports'+port.id"
                                                :value="port.id"
                                                   >
                                                 {{ port.name + "( "+ port.code + ")" }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                        </div>

                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Add Department</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>
<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { ValidationError },

    mixins: [formMixin],

    data: () => ({
        department: {
            type: 'departments',
            name: null,
            short_name: null,
            code: null,
            port_id: {
                id:null,
                type: 'ports'
            },
        },
        available_ports: [],
        station_dropdown: [],
    }),
    created () {
        this.getCategories();
    },

    methods: {

        getCategories () {
            this.$store.dispatch('ports/list').then(() => {
                this.available_ports = this.$store.getters['ports/list'];
                console.log(this.available_ports);
                if (this.available_ports && this.available_ports.length) {
                    this.department.port_id = this.available_ports[0].id;
                }
            });
        },

        created () {
        },
        async add () {
            try {
                console.log(this.department);
                await this.$store.dispatch('departments/add', this.department);
                this.notifySuccess('Department added successfully.');
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.notifyError(e.response.data.errors[0].detail);
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.notifyError('Oops, something went wrong!');
                }
            }
        },

        goBack () {
            this.$router.push({ name: 'Departments List' });
        },
    },
};
</script>
